import api from "../index";
import { qs } from "../../utils/utils.js";

export const GetUserListWithParentAndChildApi = (params) => api.get(`DropDown/GetUser-List-With-Parent-Child?${qs(params)}`);
export const StartNewChatApi = (userId) => api.post(`Chat/StartChat/${userId}`);
export const GetMessagesApi = (userId) => api.get(`Chat/Getmessages/${userId}`);
export const SendMessageApi = (data) => api.post('Chat/SendMessage', data);
export const GetChatHistoryApi = (params) => api.post('Chat/GetChatHistory', params);
export const SendMessageWithAttachmentApi = (chatId, data, header) => api.post(`Chat/AttachDocument?${chatId}`, data, header);
export const MessageredApi = (data) => api.patch('Chat/Read-UnRead-Messages', data);
export const EndchatApi = (data) => api.post(`Chat/ChatEnd/${data}`);


